import {mixins} from '../config'

import FormMixin from './form'

export default [...mixins, FormMixin]
